export default __webpack_public_path__ + "images/3a508a4ff74ef77e1b1196d92b894144.svg";